import { useState } from 'react';
import { SvgIcon } from '../../lib/svg';

// 统一描边样式：单色深棕 #6b4226，透明背景，64x64
const wrap = (inner: string) =>
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="64" height="64" fill="none" stroke="#6b4226" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">${inner}</svg>`;

interface Tpl {
  name: string;
  cat: string;
  inner: string;
}

const TPLS: Tpl[] = [
  { name: '铜香炉', cat: '清香', inner: `<path d="M12 32c0-7 9-10 20-10s20 3 20 10"/><path d="M12 32h40"/><path d="M22 38l-3 14M42 38l3 14M32 40v12"/><path d="M9 27c-3 1-4 4-3 9"/><path d="M55 27c3 1 4 4 3 9"/><path d="M30 20c-3-3 3-5 1-9M38 18c-3-3 3-5 1-9"/>` },
  { name: '清香一柱', cat: '清香', inner: `<path d="M32 54V20"/><path d="M18 54h28"/><path d="M24 54l4-7h8l4 7"/><path d="M30 12c-3-3 3-5 1-9M37 10c-3-3 3-5 1-9"/>` },
  { name: '檀香', cat: '清香', inner: `<path d="M14 38c0-5 8-7 18-7s18 2 18 7c0 3-8 4-18 4s-18-1-18-4z"/><path d="M14 38h36"/><path d="M30 24c-3 3-3 6 0 9 3-3 3-6 0-9z"/>` },
  { name: '红烛', cat: '烛光', inner: `<rect x="24" y="24" width="16" height="30" rx="2"/><path d="M32 24v-5"/><path d="M32 8c4 4 4 8 0 12-4-4-4-8 0-12z"/>` },
  { name: '长明灯', cat: '烛光', inner: `<path d="M16 40c0-6 7-9 16-9s16 3 16 9"/><path d="M16 40h32"/><path d="M22 40v5M42 40v5"/><path d="M32 26c-3 3-3 7 0 10 3-3 3-7 0-10z"/>` },
  { name: '莲花灯', cat: '烛光', inner: `<path d="M32 46c-9 0-15-5-15-11 5 0 9 3 15 9 6-6 10-9 15-9 0 6-6 11-15 11z"/><path d="M32 32c-3 3-3 7 0 10 3-3 3-7 0-10z"/>` },
  { name: '黄菊', cat: '鲜花', inner: `<circle cx="32" cy="32" r="4"/><path d="M32 32V14M32 32L48 20M32 32L50 32M32 32L48 44M32 32L32 50M32 32L16 44M32 32L14 32M32 32L16 20"/>` },
  { name: '白百合', cat: '鲜花', inner: `<path d="M32 52V30"/><path d="M32 30c-6-2-10-8-8-14 4 2 7 6 8 12 1-6 4-10 8-12 2 6-2 12-8 14z"/>` },
  { name: '玫瑰', cat: '鲜花', inner: `<path d="M32 48V30"/><path d="M32 30c-8 0-12-6-8-12 3-4 9-4 12 0 3 4-1 11-8 12z"/><path d="M29 21c-3-2-2-7 2-8 4-1 7 2 6 6"/>` },
  { name: '花圈', cat: '鲜花', inner: `<circle cx="32" cy="34" r="18"/><path d="M32 16v8M50 34h-8M32 52v-8M14 34h8"/><path d="M26 14c2-3 8-3 10 0"/>` },
  { name: '供果', cat: '供品', inner: `<path d="M32 22c-8 0-14 6-14 16s6 16 14 16 14-6 14-16-6-16-14-16z"/><path d="M32 22c0-4 3-6 6-6"/><path d="M32 22c2-4 6-4 8-2"/>` },
  { name: '糕点', cat: '供品', inner: `<rect x="16" y="20" width="32" height="28" rx="4"/><path d="M16 32h32M32 20v28"/><circle cx="24" cy="26" r="2"/><circle cx="40" cy="26" r="2"/><circle cx="24" cy="42" r="2"/><circle cx="40" cy="42" r="2"/>` },
  { name: '清酒', cat: '供品', inner: `<path d="M22 24h20l-2 20a6 6 0 0 1-6 5h-4a6 6 0 0 1-6-5z"/><path d="M22 24h20"/><path d="M28 15c0-2 8-2 8 0"/>` },
  { name: '金元宝', cat: '供品', inner: `<path d="M12 40c0-6 6-8 20-8s20 2 20 8c0 4-6 6-20 6s-20-2-20-6z"/><path d="M24 32c0-6 4-10 8-10s8 4 8 10"/>` },
  { name: '千纸鹤', cat: '追思', inner: `<path d="M32 40l-11-10 11-5 11 5z"/><path d="M21 30l-9-7 9 3z"/><path d="M43 30l9-7-9 3z"/><path d="M32 40v10"/><path d="M32 25l-4-9"/><path d="M28 16l-4-3"/>` },
  { name: '追思信', cat: '追思', inner: `<rect x="18" y="16" width="28" height="32" rx="2"/><path d="M18 22l14 10 14-10"/>` },
  { name: '牌位', cat: '臻选', inner: `<rect x="24" y="12" width="16" height="38" rx="3"/><rect x="19" y="50" width="26" height="6" rx="2"/><path d="M32 20v22"/>` },
  { name: '纸扎别墅', cat: '臻选', inner: `<path d="M14 50V30l18-13 18 13v20z"/><path d="M14 30h36"/><rect x="28" y="36" width="8" height="14"/><path d="M20 36h6v6h-6zM38 36h6v6h-6z"/>` },
];

const PROMPT = `请生成一个祭祀道具「道具名」的 SVG 图标。
要求：
- 单色（深棕色 #6b4226），风格简洁古朴，线条清晰；
- viewBox 为 "0 0 64 64"，背景透明（不要填充背景色）；
- 使用 fill="none" + stroke 描边，不要用大块填充；
- stroke-width 约 2.5，stroke-linecap / stroke-linejoin 用 round；
- 只输出 <svg> 代码本身，不要包裹 HTML 或 Markdown 代码块。`;

function CopyBox({ text, label }: { text: string; label?: string }) {
  const [copied, setCopied] = useState(false);
  return (
    <div className="mt-2">
      {label && <p className="mb-1 text-[11px] text-ink-500">{label}</p>}
      <div className="relative">
        <pre className="max-h-40 overflow-auto rounded-xl border border-ink-200 bg-ink-50/60 p-3 text-[11px] leading-relaxed text-ink-700">
          {text}
        </pre>
        <button
          onClick={async () => {
            try {
              await navigator.clipboard.writeText(text);
              setCopied(true);
              setTimeout(() => setCopied(false), 1500);
            } catch {
              /* 忽略 */
            }
          }}
          className="absolute right-2 top-2 rounded-lg bg-ink-900 px-2.5 py-1 text-[11px] text-ink-50"
        >
          {copied ? '已复制' : '复制'}
        </button>
      </div>
    </div>
  );
}

export default function AdminGuide() {
  return (
    <div className="max-w-4xl space-y-8">
      <section className="rounded-2xl border border-ink-200 bg-white p-6">
        <h2 className="font-serifcn text-xl text-ink-900">道具 SVG 图标生成规范</h2>
        <p className="mt-2 text-sm text-ink-600">
          为保持线上墓迪道具图标的统一调性，所有 SVG 图标遵循以下规范。运营在「道具管理 →
          上架道具」中粘贴 AI 生成的 SVG 代码后，前端道具列表会优先显示 SVG（无 SVG 时回退统一矢量图标）。
        </p>

        <ul className="mt-4 space-y-2 text-sm text-ink-700">
          <li>· <b>单色</b>：仅用深棕 <code className="rounded bg-ink-100 px-1">#6b4226</code> 描边，不填色块。</li>
          <li>· <b>尺寸</b>：<code className="rounded bg-ink-100 px-1">viewBox="0 0 64 64"</code>，实际渲染会自适应缩放。</li>
          <li>· <b>背景透明</b>：不要给 &lt;svg&gt; 或内部元素设置背景填充。</li>
          <li>· <b>线条</b>：<code className="rounded bg-ink-100 px-1">fill="none"</code> + <code className="rounded bg-ink-100 px-1">stroke</code>，stroke-width ≈ 2.5，端点/拐角 round。</li>
          <li>· <b>简洁古朴</b>：以线稿勾勒形态，避免复杂阴影与渐变。</li>
          <li>· <b>安全</b>：系统会自动过滤 &lt;script&gt;、on* 事件与 javascript: 协议，但请勿粘贴含脚本的 SVG。</li>
        </ul>
      </section>

      <section className="rounded-2xl border border-ink-200 bg-white p-6">
        <h3 className="font-serifcn text-lg text-ink-900">AI 生成提示词模板</h3>
        <p className="mt-1 text-sm text-ink-500">把「道具名」替换为目标道具，直接丢给任意 AI 出图/出代码工具。</p>
        <CopyBox text={PROMPT} />
      </section>

      <section className="rounded-2xl border border-ink-200 bg-white p-6">
        <h3 className="font-serifcn text-lg text-ink-900">SVG 模板库（可直接复制复用）</h3>
        <p className="mt-1 text-sm text-ink-500">
          以下为已上架道具的矢量模板，复制后粘贴到「道具图标 SVG 代码」即可一键复用；也可作为新道具的二次生成底稿。
        </p>
        <div className="mt-4 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {TPLS.map((t) => {
            const svg = wrap(t.inner);
            return (
              <div key={t.name} className="rounded-2xl border border-ink-200 bg-ink-50/40 p-4">
                <div className="flex items-center gap-3">
                  <div className="flex h-14 w-14 items-center justify-center rounded-xl border border-ink-200 bg-white">
                    <SvgIcon code={svg} size={44} />
                  </div>
                  <div>
                    <p className="text-sm text-ink-900">{t.name}</p>
                    <span className="mt-1 inline-block rounded-full bg-candle-300/30 px-2 py-0.5 text-[10px] text-candle-700">
                      {t.cat}
                    </span>
                  </div>
                </div>
                <CopyBox text={svg} />
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}
